import { TPayPackageGift } from '../../../../../../PayPackageMicrofrontend';
import { IRecommendedPackageVasGift } from '../../../../../types/reducers/recommendedPackages';

export const mapVasGifts = (gifts: Array<IRecommendedPackageVasGift>): Array<TPayPackageGift> => {
  return gifts.map(gift => {
    const { serviceType, name, count, durationInDays } = gift;

    return {
      icon: serviceType,
      name,
      count,
      durationInDays,
    };
  });
};
